// ACTIONS
export const FETCH_ACCOUNT_MANAGER = 'companyExperience/views/awaitingKickOff/FETCH_ACCOUNT_MANAGER'
export const FETCH_ACCOUNT_MANAGER_SUCCESS = 'companyExperience/views/awaitingKickOff/FETCH_ACCOUNT_MANAGER_SUCCESS'
export const FETCH_ACCOUNT_MANAGER_ERROR = 'companyExperience/views/awaitingKickOff/FETCH_ACCOUNT_MANAGER_ERROR'

// ACTION CREATORS

export const fetchAccountManager = () => ({
  type: FETCH_ACCOUNT_MANAGER,
  payload: {
    fetchingAccountManager: true,
    fetchAccountManagerError: null,
  },
})

export const fetchAccountManagerSuccess = ({ result }) => ({
  type: FETCH_ACCOUNT_MANAGER_SUCCESS,
  payload: {
    fetchingAccountManager: false,
    accountManager: result,
    lastUpdatedAccountManager: Date.now(),
  },
})

export const fetchAccountManagerError = errorMessage => ({
  type: FETCH_ACCOUNT_MANAGER_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

// REDUCERS
const defaultUtils = {
  fetchingAccountManager: false,
  fetchAccountManagerError: null,
  lastUpdatedAccountManager: null,
}

const utils = (state = defaultUtils, { type, payload }) => {
  switch (type) {
    case FETCH_ACCOUNT_MANAGER:
    case FETCH_ACCOUNT_MANAGER_SUCCESS:
      return {
        ...state,
        ...payload,
      }
    case FETCH_ACCOUNT_MANAGER_ERROR:
      return {
        ...state,
        fetchingAccountManager: false,
        fetchAccountManagerError: payload,
      }
    default:
      return state
  }
}

export default utils

export const getAwaitingKickOffView = state => state.views.awaitingKickOff || defaultUtils
